(function () {
  function scrollToTarget(id) {
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start',
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-jojo-banner-scroll]');
    if (!button) return;

    var id = (button.getAttribute('data-jojo-banner-scroll') || '').replace(/^#/, '').trim();
    if (!id || !document.getElementById(id)) return;

    event.preventDefault();
    scrollToTarget(id);
  });
})();
